import * as React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ScoreCircle from './ScoreCircle.component';

const styles = {
  root: {
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'flex-start',
    height: 90,
    paddingLeft: 8,
  },
  cell: {
    fontWeight: 'bold',
    marginRight: 8,
    fontSize: 'large', // '1.2rem', or '18px', 'large', etc.
  },
};

class SectionSummary extends React.PureComponent {
  static propTypes = {
    classes: PropTypes.any.isRequired,
    raw: PropTypes.number,
    scaled: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    letter: PropTypes.string,
  };
  render() {
    const { raw, scaled, letter, classes } = this.props;
    return (
      <div id="reportSectionSummary" className={classes.root}>
        <ScoreCircle score={scaled} grade={letter} rawScore={raw} />
      </div>
    );
  }
}
export default withStyles(styles)(SectionSummary);
